export default "assets/images/icons/star-1585290c.svg";